import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './CookieSettingsButton.css';

const CookieSettingsButton = ({ onOpenSettings }) => {
  const { t } = useTranslation('cookiebanner');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`cookie-settings-button-container ${isVisible ? 'visible' : ''}`}>
      <button 
        className="cookie-settings-button"
        onClick={onOpenSettings}
        aria-label={t('settingsButton.ariaLabel')}
        title={t('settingsButton.title')}
      >
        <span className="cookie-settings-icon">🍪</span>
        <span className="cookie-settings-text">{t('settingsButton.text')}</span>
      </button>
    </div>
  );
};

export default CookieSettingsButton;